import React from "react";
import { Minus, Plus } from "lucide-react";
import "./Stepper.scss";

interface StepperProps {
  value: number;
  onChange: (v: number) => void;
  min: number;
  max?: number;
  disabled?: boolean;
}

// A small [-] value [+] control, reused for split counts and share counts.
const Stepper: React.FC<StepperProps> = ({
  value,
  onChange,
  min,
  max,
  disabled,
}) => (
  <div className="stepper">
    <button
      type="button"
      className="stepper-btn"
      disabled={disabled || value <= min}
      onClick={() => onChange(value - 1)}
    >
      <Minus size={12} />
    </button>
    <span className="stepper-value">{value}</span>
    <button
      type="button"
      className="stepper-btn"
      disabled={disabled || (max !== undefined && value >= max)}
      onClick={() => onChange(value + 1)}
    >
      <Plus size={12} />
    </button>
  </div>
);

export default Stepper;
